<form [formGroup]="vacReqForm" id="create-edit-item-config-popup" fxLayout="column"
  style="overflow: hidden; margin: 10px 6px; margin-bottom: 0px; height: 100%;" fxLayout="column">
  <lib-popup-header [title]="popupTitle" [isMaximized]="isMaximized" [useCustomClose]="true"
    (isPopupMaximized)="setGridHeight($event)" (popupClosed)="close()">
  </lib-popup-header>

  <app-loader *ngIf="VacationRequestService.apiCallsInProgress > 0"></app-loader>


  <div fxLayout="row" fxLayoutAlign="space-between">
    <div class="row field no-border" style="margin-left: 1px">
      <div style="display: flex; flex-direction: row; align-items: baseline;">
        <label style="font-weight: 500;" class="control-label col-md-auto mt-2">Reporter: </label>
        <div style="display: flex; flex-direction: row; gap: 15px; align-items: baseline;">
          <span class="pt-2" style="min-width: 60px;">
            {{ vacReqForm.get('reporter')?.value}}
          </span>
          <i *ngIf="getPermission('popup_icon_selectResource')?.visible && !popupData?.vrfId"
            class="fa-solid fa-user pointer me-5" style="color: #000;" (click)="showResourcesPopup = true;"></i>
        </div>
      </div>
    </div>

    <div fxLayout="row" class="field no-border">
      <div style="margin-right: 15px;">
        <label class="control-label col-md-auto mt-2">Status: </label>
      </div>
      <div>
         <ejs-textbox trimOnBlur formControlName="status"></ejs-textbox>
      </div>
    </div>
    <div class="comments-section position-relative">
      <a *ngIf="popupData?.vrfId" class="comments-opener" href="javascript:" (click)="showComments()">
        <i class="fas fa-comment me-2" [ngStyle]="{'color': $safeNavigationMigration(sharedService.globalComments?.commentColor)}"></i>
        <span>{{sharedService?.globalComments?.commentCount}}</span> Comment(s)</a>
    </div>
    <div class="tabs">
      <div class="col tabbable-line pt-1">
        <ul class="nav nav-tabs float-end" id="tabs">
          <li class="nav-item">
            <a class="nav-link position-relative" href="javascript:void(0)" [ngClass]="{'active': tab === 'details'}"
              (click)="onTabChange('details')" title="Details">Details</a>
          </li>
          <li class="nav-item">
            <a class="nav-link position-relative" href="javascript:void(0)"
              [ngClass]="{'active': tab === 'attachments'}" (click)="onTabChange('attachments')" title="Attachments"><i
                class="fas fa-file-upload" [ngStyle]="{'color': popupData.attColorCode }"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [ngClass]="{'active': tab === 'history'}"
              (click)="onTabChange('history')" title="History"><i class="fas fa-history"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>


  <div class="row">
    <div class="container-fluid">
      <div class="tab-content custom-scrollbar flex-fill" [ngStyle]="{
          'overflow-y': 'auto',
          'max-height': isMaximized ? 'calc(100vh - 183px)' : 'calc(100vh - 360px)',
          
        }">
        <div id="prp-details-tab" class="tab-pane" [ngClass]="{'active show': tab === 'details'}">



          <div style="margin-top: 0px !important;" class="card mb-2">
            <div class="card-header d-flex ps-0" data-bs-toggle="collapse" [attr.href]="'#items-section3'">
              <a style="text-decoration: none; display: flex;" class="card-link flex-fill">
                <span class="me-2">Requested Days</span>&nbsp;
                <span *ngIf="isRequestedDaysSectionInvalid()">
                  <span class="diplay">
                    <i class="fa-solid fa-circle-exclamation"
                      style="color: #e60a0a;font-size: 16px; background-color: whitesmoke; border-radius: 50%;"></i>
                  </span>
                  <span class="alert alert-danger py-0 mb-0" style="border-radius: 4%;" role="alert">
                    Please enter duration for at least one out of office category
                  </span>
                </span>
              </a>
              <i class="fas fa-chevron-up"></i>
            </div>
            <div [id]="'items-section3'" class="collapse show">
              <div class="card-body-section">
                <div class="row mx-1">
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label mb-1">Vacation:</label>
                      <ejs-numerictextbox formControlName="vacation" [min]="0" [max]="365" format="n0" [decimals]="0"
                        [showSpinButton]="false" [validateDecimalOnType]="true"
                        (change)="onFieldChange($event, 'vacation'); fetchEndDateAndImpacts($event)">
                      </ejs-numerictextbox>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label mb-1">Floating:</label>
                      <ejs-numerictextbox formControlName="floating" [min]="0" [max]="365" format="n0" [decimals]="0"
                        [showSpinButton]="false" [validateDecimalOnType]="true"
                        (change)="onFieldChange($event, 'floating'); fetchEndDateAndImpacts($event)">
                      </ejs-numerictextbox>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label mb-1">Sick:</label>
                      <ejs-numerictextbox formControlName="sick" [min]="0" [max]="365" format="n0" [decimals]="0"
                        [showSpinButton]="false" [validateDecimalOnType]="true"
                        (change)="onFieldChange($event, 'sick'); fetchEndDateAndImpacts($event)">
                      </ejs-numerictextbox>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label mb-1">Other:</label>
                      <span *ngIf="getPermission('popup_icon_addOtherDays')?.visible && popupData?.canEdit">&nbsp;
                        <i class="fas fa-pencil pointer" title="Add/Edit other days"
                          (click)="openOtherVRPopup('canEdit');"></i>
                      </span>
                      <span *ngIf="getPermission('popup_icon_viewOtherDays')?.visible && !popupData?.canEdit">&nbsp;<i
                          class="fas fa-tasks pointer" title="Detailed View"
                          (click)="openOtherVRPopup('readOnly');"></i>
                      </span>

                      <ejs-numerictextbox formControlName="otherDays" [min]="0" [max]="365" format="n0" [decimals]="0"
                        [showSpinButton]="false" [validateDecimalOnType]="true">
                      </ejs-numerictextbox>
                    </div>
                  </div>
                </div>
                <div class="row mx-1">
                  <div class="col-2">
                    <label class="field-label">Start Date:<span class="required-asterik">*</span></label>
                    <div>
                      <ejs-datepicker [min]="startOfTheYear" style="padding-left: 0px" formControlName="startDate"
                        format="d MMM, y" (renderDayCell)="onRenderCell($event)"
                        (change)="fetchEndDateAndImpacts($event);" (keydown)="$event.preventDefault();">
                      </ejs-datepicker>
                    </div>
                    <span *ngIf="vacReqForm?.controls && isStartDateMissing()" class="error_control error-tooltip">Start
                      Date is Required
                    </span>
                  </div>
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label">Duration: </label>
                       <ejs-textbox trimOnBlur [placeholder]="'Duration'" formControlName="totalDays"></ejs-textbox>
                    </div>
                  </div>

                  <div class="col-2">
                    <label class="field-label">End Date:</label>
                    <div>

                       <ejs-textbox trimOnBlur formControlName="endDate" format="d MMM, y"></ejs-textbox>
                    </div>

                  </div>

                  <div class="col-2">


                  </div>
                </div>




              </div>
            </div>
          </div>
          <div style="margin-top: 0px !important;" class="card mb-2">
            <div class="card-header d-flex ps-0" data-bs-toggle="collapse" [attr.href]="'#items-section'">
              <a class="card-link flex-fill" style="text-decoration: none;">
                <span class="me-2">Remaining Days</span>
              </a>
              <i class="fas fa-chevron-up"></i>
            </div>
            <div [id]="'items-section'" class="collapse show">
              <div class="card-body-section">

                <div class="row mx-1">
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label">Vacation:</label>
                       <ejs-textbox trimOnBlur formControlName="remainingVacation" placeholder="Vacation">
                      </ejs-textbox>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label">Floating:</label>
                       <ejs-textbox trimOnBlur formControlName="remainingFloating" placeholder="Floating">
                      </ejs-textbox>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="w-75">
                      <label class="field-label">Sick:</label>
                       <ejs-textbox trimOnBlur formControlName="remainingSick" placeholder="Sick">
                      </ejs-textbox>
                    </div>
                  </div>
                </div>




              </div>
            </div>
          </div>
          <div style="margin-top: 0px !important;" class="card mb-2">
            <div class="card-header d-flex ps-0" data-bs-toggle="collapse" [attr.href]="'#items-section2'">
              <a class="card-link flex-fill" style="text-decoration: none;">
                <span class="me-2">Impact</span>
              </a>
              <i class="fas fa-chevron-up"></i>
            </div>
            <div [id]="'items-section2'" class="collapse show">
              <div class="card-body-section">

                <div class="w-100" style="overflow-y: auto">
                  <ejs-treegrid #impactsTreeGrid id="impactsTreeGrid" [height]="gridHeight" [dataSource]="impactData"
                    [allowPaging]='false' [treeColumnIndex]='0' [rowHeight]="30" parentIdMapping="parentId"
                    idMapping="id" [allowFiltering]="true" [allowSorting]="true"
                    [sortSettings]="{columns: [{field: 'startDate', direction: 'Ascending'}] }" [allowResizing]="true"
                    [enableCollapseAll]="false" [allowReordering]="true" [allowExcelExport]="true" [gridLines]="false"
                    [showColumnChooser]="true" [allowSelection]="true" [filterSettings]="{ type: 'Menu' }"
                    [selectionSettings]="selectionSettings" (dataBound)="dataBound()"
                    (actionComplete)="actionComplete($event, impactsGrid)" (toolbarClick)="onToolbarClick($event)">
                    <e-columns>
                      <e-column *ngFor="let column of impactsGridColumns;" [field]="column.field"
                        [headerText]="column.headerText" [type]="column.type" [width]="column.width"
                        [filter]="column.filter ? column.filter : { type: 'Menu' }"
                        [format]="column.format ? column.format : null" [textAlign]="column.textAlign"
                        [visible]="column.visible" [freeze]="column.freeze"
                        [showInColumnChooser]="column.showInColumnChooser ?? true"
                        [commands]="column?.commands ? column.commands : null" [allowEditing]="column.allowEditing"
                        [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true"
                        [allowSorting]="column.allowSorting" [allowReordering]="column.allowReordering??true">


                        <ng-template *ngIf="column.field === 'title'" #template let-data>
                          @if (data['type'] === 'Opportunity' && data['hyperlinkEnabled'] && config?.appName === 'sales') {
                          <span> <i class="fa-solid fa-layer-group" style="color:#2c7cd1;"></i>
                            <a href="javascript:" (click)="openOpportunityPopup($safeNavigationMigration(data?.id))">&nbsp;
                             {{data['title']}}</a>
                          </span>
                          } @else if (data['type'] === 'SalesOrder' && data['hyperlinkEnabled'] && config?.appName === 'sales') {
                          <span> <i class="fa-solid fa-layer-group" style="color:#2c7cd1;"></i>
                            <a href="javascript:" (click)="openSalesOrderPopup(data?.id)">&nbsp;
                            {{data['title']}}</a>
                          </span>
                          } @else if (data['type'] === 'ToDo' && data['hyperlinkEnabled'] && config?.appName === 'sales') {
                          <span> 
                            <i class="fa-solid fa-bars-progress"></i>&nbsp;
                            <a href="javascript:" (click)="openToDosPopup($safeNavigationMigration(data?.id))">
                             {{data['title']}}</a>
                          </span>
                          } @else {
                          <span> <i class="fa-solid fa-clipboard-list" style="color:green;"></i>&nbsp;
                           {{data['title']}}</span>
                          }
                          
                        </ng-template>
                        <ng-template *ngIf="column.field === 'customer'" #template let-data>
                          @if(data['hyperlinkEnabled'] && config?.appName === 'sales') {
                            <a href="javascript:" (click)="openProspectPopup(data.customerId)">
                            {{ data.customer }}
                            </a>
                          } @else {
                           {{ data.customer }}
                          }
                        </ng-template>

                        @if (column?.field === 'status') {
                        <ng-template #template let-data>
                          <span class="grid-status-column {{data.isOverdue ? 'overdue' : ''}}" [ngStyle]="{'background-color': !data.isOverdue && data?.statusColor ?? '#80808011'}">
                           <i class="fas fa-info me-1" *ngIf="data.isOverdue"></i> {{data.status}}
                          </span>
                        </ng-template>
                        }
                        @if (column?.field === 'type') {
                        <ng-template #template let-data>
                          {{parseType(data.type)}}
                        </ng-template>
                        }

                      </e-column>
                    </e-columns>
                  </ejs-treegrid>
                </div>

              </div>
            </div>
          </div>







        </div>

        <div id="prp-links-tab" class="tab-pane"
          [ngClass]="{'active show': tab === tabsModel.links || tab === 'links'}">
          <app-links [primaryId]="popupData?.vrfId ?? popupData?.id" [moduleName]="moduleName"></app-links>
        </div>

        <div id="prp-attachments-tab" class="tab-pane"
          [ngClass]="{'active show': tab === tabsModel.attachments || tab === 'attachments'}">
          <app-attachments [primaryId]="popupData?.vrfId ?? popupData?.id" [moduleName]="moduleName"></app-attachments>
        </div>

        <div id="prp-history-tab" class="tab-pane"
          [ngClass]="{'active show': tab === tabsModel.history || tab === 'history'}">
          <app-history [primaryId]="popupData?.vrfId ?? popupData?.id" [moduleName]="moduleName"></app-history>
        </div>
      </div>
    </div>
  </div>
</form>

<ng-template #columnChooser>
  <lib-column-chooser
     [grid]="impactsTreeGrid"
  ></lib-column-chooser>
</ng-template>

 <div class="modal-footer mt-2 sticky bottom-0 bg-white z-10 w-full flex flex-wrap items-center justify-end">
    <button type="button" class="btn btn-sm btn-danger footer-buttons" (click)="close()">
      Close
    </button>

    <button *ngIf="popupData?.canReject" type="button" class="btn btn-sm btn-danger footer-buttons" (click)="rejectRequest()">
      Reject
    </button>

    <button *ngIf="popupData?.canApprove" type="button" class="btn btn-sm btn-success footer-buttons"
      (click)="updateStatusTo(vrStatuses.approved)">
      Approve
    </button>

    <button *ngIf="popupData?.canEdit" type="button" class="btn btn-sm btn-warning footer-buttons" [disabled]="!hasUnsavedChanges"
      [title]="hasUnsavedChanges ? '' : 'Nothing has changed yet'" (click)="resetPopup()">
      Reset
    </button>

    <button *ngIf="popupData?.canReopen" type="button" class="btn btn-sm btn-warning footer-buttons"
      (click)="updateStatusTo(vrStatuses.open)">
      Reopen
    </button>

    <button *ngIf="popupData?.canEdit" type="button" class="btn btn-sm btn-success footer-buttons" (click)="savePopup(true, vrStatuses.open)">
      Save & Close
    </button>

    <button *ngIf="popupData?.canEdit" type="button" class="btn btn-sm btn-success footer-buttons"
      (click)="savePopup(false, vrStatuses.submitted)">
      Submit
    </button>
  </div>



@if (showResourcesPopup) {
<app-vr-resources-popup (onClose)="onResourcesPopupClose($event)"></app-vr-resources-popup>
}